module.exports = __webpack_public_path__ + "img/company-header.9d3473ce.png";